import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import ModalContentBase from "../modal_content_base";
import ModalLoader from "../modal_loader";
import ModalAlert from "../modal_alert";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    circleId: PropTypes.number.isRequired,
    currentUser: PropTypes.object,
    userSignedIn: PropTypes.bool,
    isReloadRequired: PropTypes.bool,
  },
  getInitialState() {
    return {
      isEventCreateRequestSent: false,
    };
  },
  sendEventCreateRequest() {
    const { circleId } = this.props;
    this.modalLoader.openModal();
    $.ajax({
      url: "/api/circle/send_event_create_request",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        circle_id: circleId,
      },
    })
      .done(
        function(data) {
          this.modalLoader.closeModal();
          this.setState({
            isEventCreateRequestSent: true,
          });
          
        }.bind(this)
      )
      .fail(
        function(_xhr, _status, data) {
          // error
          this.modalLoader.closeModal();
          if (data === "Forbidden") {
            this.disableJoinErrorAlert.openModal();
          } else {
            this.systemErrorAlert.openModal();
          }
        }.bind(this)
      );
  },
  closeModalBtn() {
    this.modalJoinRequest.closeModal();
  },
  render() {
    const previewContent = (
      <button
        type="button"
        className="a-button a-button__top a-button__top--outline mt-0 mb-2 w-100"
      >
        イベント企画リクエストへ進む
      </button>
    );

    let modalContent = "";
    if (!this.state.isEventCreateRequestSent) {
      modalContent = 
        <div className="card bg-gray" style={{ padding: "16px 16px 16px" }}>
          <button
            type="button"
            className="close close__modal position-absolute position--modalclose"
            aria-label="Close"
            onClick={this.closeModalBtn}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h6 className="text-fw-bold text-center mb-3_5">イベント企画をリクエスト</h6>
          <p className="text-fz-small mb-0 mx-3">サークルのクリエイター（管理人）にイベント企画をリクエストします。送信者のお名前はお相手には表示されません。</p>
          <div className="card bg-gray scrollable-list-y border-0 p-3 mb-2">
          <button
            className="a-button a-button__top a-button--orange mr-auto ml-auto mt-2 mb-2 w-100"
            onClick={this.sendEventCreateRequest}
          >
            イベント企画をリクエストする
          </button>
        </div>
      </div>;
    } else if (this.state.isEventCreateRequestSent) {
      modalContent = (
        <div>
          <div className="modal-view-header">
            <p
              className="bold"
              style={{ margin: "0px 0px 6px", paddingTop: "1.5em" }}
            >
              イベント企画リクエスト完了
            </p>
          </div>
          <div>
            <p className="mb-4 text-center">
              現在このサークルにイベント企画をリクエストしています。
            </p>
          </div>
        </div>
      );
    }
    return (
      <div>
        <ModalContentBase
          ref={(c) => {
            this.modalJoinRequest = c;
          }}
          previewContent={previewContent}
          modalContent={modalContent}
        />
        <ModalLoader
          ref={(c) => {
            this.modalLoader = c;
          }}
        />
        <ModalAlert
          ref={(c) => {
            this.signInAlert = c;
          }}
          title="ログイン"
          content="この操作にはログインまたは会員登録が必要です。"
        />
        <ModalAlert
          ref={(c) => {
            this.systemErrorAlert = c;
          }}
          title="エラー"
          content="時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.disableJoinErrorAlert = c;
          }}
          title="エラー"
          content="お客様は、このサークルのイベントにリクエストする権限がございません。"
        />
      </div>
    );
  },
});
